<template>
  <div class="cq-page">
    <query-result :key="routeKey" :api="api" :payload="payload" :template-id="templateId" :template-name="templateName" />
  </div>
</template>

<script>
import queryResult from '../views/query-result.vue'
import { getCustomQueryApi, PAYLOAD_KEY } from '../runtime'

export default {
  name: 'custom-query-result-page',
  components: { queryResult },
  data() {
    return {
      mark: '',
      templateId: '',
      templateName: '',
      payload: null,
      api: getCustomQueryApi()
    }
  },
  computed: {
    routeKey() {
      return JSON.stringify(this.$route.query)
    }
  },
  created() {
    this.syncRouteQuery()
  },
  beforeRouteUpdate(to, from, next) {
    this.syncRouteQuery()
    next()
  },
  methods: {
    syncRouteQuery() {
      this.mark = this.$route.query.mark || ''
      this.templateId = this.$route.query.templateId || ''
      this.templateName = this.$route.query.templateName || ''
      // 读取缓存的查询配置：配置页执行为完整 payload；历史模板执行为 { queryJson, templateId, templateName }
      let cache = localStorage.getItem(PAYLOAD_KEY)
      if (cache) {
        try {
          this.payload = JSON.parse(cache)
        } catch (e) {
          this.payload = null
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.cq-page {
  min-height: 100%;
  background: #f0f2f5;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/pages/result-page.vue